import { customAlphabet } from 'nanoid'

export const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
export const lowercase = 'abcdefghijklmnopqrstuvwxyz'
export const numbers = '0123456789'
export const alphanumeric = numbers + lowercase + uppercase

/**
 * Generate a unique ID
 * @returns A unique ID
 */
export const genId = customAlphabet(alphanumeric, 26)

/**
 * 为 Promise 添加最小延迟
 * @param p 要延迟的 Promise
 * @param ms 最小延迟时间（毫秒）
 * @returns 带有最小延迟的 Promise
 */
export const withMinDelay = <T>(p: Promise<T>, ms = 200) =>
  Promise.all([p, new Promise(resolve => setTimeout(resolve, ms))]).then(([mod]) => mod as T)
